import { DateService, PageEvent } from '@pulse/browser-shared';
import { PulseStorage, TrackerConfigurations } from '@pulse/common';
import { ActivityTracker } from '../activity.tracker';

export class ActivitySynchronizer {
    private pageEvents: PageEvent[] = [];

    constructor(
        private persistentStorage: PulseStorage,
        private activityTracker: ActivityTracker,
        private date: DateService,
        private config: TrackerConfigurations,
    ) {
        this.persistentStorage.freeSpace$.subscribe(() => {
            this.clearClosedTabsActivity();
        });
    }

    startService(tabId: string) {
        this.activityTracker.interactions().subscribe((e) => {
            const now = this.date.now();
            this.pageEvents.push(e);
            this.pageEvents = this.pageEvents
                .slice(this.pageEvents.length - 100)
                .filter((i) => now - i.ts <= this.config.tabOpenerDetectionTimeWindow);
            if (this.pageEvents.length) {
                this.persistentStorage.setJSON(`tab_activity_${tabId}`, this.pageEvents);
            } else {
                this.remove(tabId);
            }
        });
        this.clearClosedTabsActivity();
    }

    getTabEvents(tabId: string): PageEvent[] | null {
        return this.persistentStorage.getJSON<PageEvent[]>(`tab_activity_${tabId}`);
    }

    remove(tabId: string) {
        this.persistentStorage.remove(`tab_activity_${tabId}`);
    }

    private clearClosedTabsActivity() {
        const openTabIds = this.fetchOpenTabIds();
        this.persistentStorage
            .keys()
            .filter((key) => key.startsWith('tab_activity_'))
            .filter((key) => {
                const lastActivityTime = this.getTabEvents(key.replace('tab_activity_', ''))
                    ?.map((event) => event.ts)
                    .reduce((largestTs, currentTs) => Math.max(largestTs, currentTs));

                if (!lastActivityTime) {
                    return true;
                }
                if (
                    this.date.now() - lastActivityTime >
                    this.config.tabOpenerDetectionTimeWindow + 5000
                ) {
                    return true;
                }
                if (openTabIds.indexOf(key.replace('tab_activity_', '')) === -1) {
                    return true;
                }

                return false;
            })
            .map((key) => this.persistentStorage.remove(key));
    }

    private fetchOpenTabIds(): string[] {
        return this.persistentStorage
            .keys()
            .filter((key) => key.startsWith('tab_info_'))
            .map((key) => key.replace('tab_info_', ''));
    }
}
